export type AiQueueUiStatus = "waiting" | "timeout";

export type AiQueueUiState = {
  status: AiQueueUiStatus;
  position: number;
  upgradeUrl: string;
};

type Listener = (state: AiQueueUiState | null) => void;

let current: AiQueueUiState | null = null;
const listeners = new Set<Listener>();

export function getAiQueueUi(): AiQueueUiState | null {
  return current;
}

export function publishAiQueueUi(next: AiQueueUiState | null): void {
  current = next;
  listeners.forEach((listener) => listener(current));
}

export function subscribeAiQueueUi(listener: Listener): () => void {
  listeners.add(listener);
  listener(current);
  return () => {
    listeners.delete(listener);
  };
}
